import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAdminToken } from '../lib/api';

export default function Login() {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = token.trim();
    if (!trimmed) {
      setError('Please enter the admin token');
      return;
    }
    setAdminToken(trimmed);
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <span className="text-4xl">🍴</span>
          <h1 className="text-2xl font-bold mt-2">EatEmAll Admin</h1>
          <p className="text-sm text-gray-500 mt-1">Enter your admin token to continue</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Admin Token
            </label>
            <input
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              autoFocus
              className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded text-white focus:outline-none focus:border-brand-500"
              placeholder="Enter admin token..."
            />
          </div>
          {error && <p className="text-sm text-red-400">{error}</p>}
          <button
            type="submit"
            className="w-full px-4 py-2 bg-brand-600 hover:bg-brand-700 text-white rounded font-medium transition"
          >
            Login
          </button>
        </form>
        <p className="text-xs text-gray-600 mt-4 text-center">
          In local dev (no ADMIN_TOKEN set), any value works.
        </p>
      </div>
    </div>
  );
}
